export default {
  title: "Provincia"
  , form: {
    codigo: {
      label: "Código"
      , th: "Código"
    }
    , nombre: {
      label: "Nombre"
      , th: "Nombre"
    }
  }
  , errors: {
    BD6000: { text: "Ocurrió un error en el catálogo de Provincia" }
    , WS6000: { text: "Ocurrió un error en el catálogo de Provincia" }
    , JS6000: { text: "Ocurrió un error en el catálogo de Provincia" }
    , CR6000: { text: "Ocurrió un error en el catálogo de Provincia" }
    , UK_Provincia: { text: "Ya existe un registro con el mismo código" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/geograficos/provincia.js